const DISPLAY_MAX_ROWS_KEY = "display.max_rows"

/**
 * Clear all user preferences from storage
 */
export const clearPreferences = (): boolean | null => {
  try {
    localStorage.removeItem(DISPLAY_MAX_ROWS_KEY)
    return true
  } catch (error) {
    console.error("Failed to delete preferences:", error)
    return null
  }
}
